// Tab switching functionality for Fearrington Village maps
(function () {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function () {
    const tabLinks = document.querySelectorAll('.fv-tabs-nav a');

    tabLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        // Get the target tab ID
        const targetId = this.getAttribute('href');

        // Remove active class from all tabs and tab content
        document.querySelectorAll('.fv-tabs-nav li').forEach(function (li) {
          li.classList.remove('active');
        });
        document.querySelectorAll('.fv-tab-content').forEach(function (content) {
          content.classList.remove('active');
        });

        // Add active class to clicked tab and corresponding content
        this.parentElement.classList.add('active');
        const targetContent = document.querySelector(targetId);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  });
})();
